import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import AddProductMergeDefaultMutation from '@/graphql/contracts/addProductMergeDefault.mutation.gql';
import { AddProductMergeDefault, AddProductMergeDefaultVariables }
  from '@/graphql/contracts/_generated_/addProductMergeDefault.mutation';

export default function useAddProductMergeDefault() {
  const [addProductMergeDefault, { loading, error }] = useMutation<
  AddProductMergeDefault,
  AddProductMergeDefaultVariables
  >(AddProductMergeDefaultMutation, {
    client: apolloClientContracts,
    refetchQueries: ['GetPaginatedFilteredProducts'],
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const addMergeDefault = (fields: AddProductMergeDefaultVariables, successCb?: () => void) => {
    addProductMergeDefault({
      variables: { ...fields },
      onCompleted: () => {
        notificationService.open({
          title: 'Product Merge Default',
          text: 'Product merge default successfully added',
          type: 'success',
        });

        if (successCb) {
          successCb();
        }
      },
    });
  };

  return {
    addMergeDefault,
    isLoadingAddMergeDefault: loading,
    errorAddMergeDefault: error,
  } as const;
}
